import { render, staticRenderFns } from "./CommunicationMethodSelection.vue?vue&type=template&id=2e77cf5e&"
import script from "./CommunicationMethodSelection.vue?vue&type=script&lang=js&"
export * from "./CommunicationMethodSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports